import React, { ReactNode } from "react";
import { PiInfo } from "react-icons/pi";
import { AppContext } from '../AppContext';
class PopupWindow extends React.Component<
  { children: ReactNode, title: string, closeClicked: (callback?: ()=> void) => void , info?: string, hasClose?: boolean, additionalClass?: string}, 
  {

  }
> {

  static defaultProps = {
    info: "",
    hasClose: true,
    additionalClass: ""
  }

  handleContainerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Stop event propagation to avoid bubbling up to parent elements
    e.stopPropagation();
  }

  componentDidMount(): void {
    (this.context as any).showPopup(true);
  }
  componentWillUnmount(): void {
    (this.context as any).showPopup(false);
  }
  render() {
    return (
      <>
        {/* Pernilles popup stucture */}

        <div className="transparentWrapper">
          
          <div className={"popupContainer " +this.props.additionalClass} onClick={this.handleContainerClick}>
            <button className="overlayClose" onClick={(e) => { this.props.closeClicked();  e.stopPropagation(); }}>
          </button>
            <div className="popupTopbar">
              <div className="popupTitle">
                <h1>{this.props.title}</h1>
                {(this.props.info) ?
                <div title={this.props.info}>
                  <PiInfo className="buttonIcon"/>
                </div>:<></>
                }
                {
                  this.props.hasClose ?   <button className="bigClose buttonIcon intuiButton" onClick={(e) => { this.props.closeClicked();  e.stopPropagation(); }}>
                  X
                  </button> :<></>
                }
             
              </div>
              
            </div>
            <div className="popupMainbar">
              <div className="popupContent">
                {this.props.children}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
PopupWindow.contextType = AppContext;
export default PopupWindow;